import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_CRUD} from './_Action'
import {_PAGINATE} from './paginateAction'
import { PublicProductCriteria } from 'src/type/criteria/publicProductCriteria'

export const CLOSED_SUBSCRIPTION = 'closedSubscription'
const _CLOSED_SUBSCRIPTION_PAGINATE = _PAGINATE(CLOSED_SUBSCRIPTION)
export const OPENED_SUBSCRIPTION = 'openedSubscription'
const _OPENED_SUBSCRIPTION_PAGINATE = _PAGINATE(OPENED_SUBSCRIPTION)

export const fetchPublicProductsCS = (criteria: PublicProductCriteria) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_CLOSED_SUBSCRIPTION_PAGINATE.REQUEST, _CLOSED_SUBSCRIPTION_PAGINATE.SUCCESS, _CLOSED_SUBSCRIPTION_PAGINATE.FAILURE],
      route: route.publicProducts.search(criteria)
    }
  })
}

export const fetchPublicProductsOS = (criteria: PublicProductCriteria) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_OPENED_SUBSCRIPTION_PAGINATE.REQUEST, _OPENED_SUBSCRIPTION_PAGINATE.SUCCESS, _OPENED_SUBSCRIPTION_PAGINATE.FAILURE],
      route: route.publicProducts.search(criteria)
    }
  })
}

// ====================== FETCH MORE =================================
export const fetchMorePublicProductsCS = (criteria: PublicProductCriteria) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_CLOSED_SUBSCRIPTION_PAGINATE.FETCH_MORE_REQUEST, _CLOSED_SUBSCRIPTION_PAGINATE.FETCH_MORE_SUCCESS, _CLOSED_SUBSCRIPTION_PAGINATE.FETCH_MORE_FAILURE],
      route: route.publicProducts.search(criteria)
    }
  })
}
  
export const fetchMorePublicProductsOS = (criteria: PublicProductCriteria) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_OPENED_SUBSCRIPTION_PAGINATE.FETCH_MORE_REQUEST, _OPENED_SUBSCRIPTION_PAGINATE.FETCH_MORE_SUCCESS, _OPENED_SUBSCRIPTION_PAGINATE.FETCH_MORE_FAILURE],
      route: route.publicProducts.search(criteria)
    }
  })
}

export const PUBLIC_PRODUCT = 'publicProduct'
const _PUBLIC_PRODUCT = _CRUD(PUBLIC_PRODUCT)

export const getPublicProduct = (id: string) => (dispatch, getState: () => RootState) => {
    return dispatch({
      [_CALL_API]: {
        types: [_PUBLIC_PRODUCT.GET.REQUEST, _PUBLIC_PRODUCT.GET.SUCCESS, _PUBLIC_PRODUCT.GET.FAILURE],
        route: route.publicProducts.getById(id)
      }
    })
}


// WEBPACK FOOTER //
// ./src/core/redux/action/publicProductsAction.ts